import { ProjectData } from '../../../lib/propertyTypes';

export const extractPropertyTypeFromProjectData = (
  projectData: ProjectData,
): string => {
  return (
    projectData.unit_types?.[0]?.property_type?.property_type?.name ||
    projectData.property_type_code.toLowerCase()
  );
};
